'use strict';

angular.module('bringgApp').config(function (ngClipProvider) {
	ngClipProvider.setPath('../../node_modules/zeroclipboard/dist/ZeroClipboard.swf');
});
